import React from "react";
import styled from "@emotion/styled";
import { Flex } from "styles/utility-components";

import { DEFAULT_VIEW_IDS } from "components/homepage/util";
import { generateNoticeSearchUrl } from "components/notices/utils";
import Button from "components/ui/button/Button";
import EmptyState from "components/ui/empty_state/EmptyState";
import { EventData, EventNames, useTracking } from "lib/tracking";

const HELP_URL = "https://help.stotles.com/faqs#how-to-build-pipeline-with-opportunities";

type PipelineEmptyStateProps = {
  eventData: EventData;
};

function OpportunityPipelineEmptyState({ eventData }: PipelineEmptyStateProps) {
  const { logEvent } = useTracking();

  return (
    <EmptyState
      type="startingState"
      heading="Your pipeline's waiting!"
      description={
        <Description>
          Browse expiring notices to uncover deals worth chasing. Save them to your Opportunity
          pipeline to activate AI-powered qualification and start engaging with the buyer
        </Description>
      }
      width="100%"
      size="large"
      action={
        <Flex gap={8} flexWrap="wrap" justifyContent="center">
          <Button
            as="a"
            href={generateNoticeSearchUrl({}, DEFAULT_VIEW_IDS.upcomingContractExpiries)}
            target="_blank"
            onClick={undefined}
          >
            Browse expiring notices
          </Button>
          <Button
            as="a"
            href={HELP_URL}
            target="_blank"
            buttonType="secondary"
            onClick={() =>
              logEvent(EventNames.clickedHelpCentre, {
                ...eventData,
                "Destination url": HELP_URL,
              })
            }
          >
            Learn more about Opportunities
          </Button>
        </Flex>
      }
    />
  );
}

const Description = styled(Flex)({
  maxWidth: 400,
});

export default OpportunityPipelineEmptyState;
